import { regions } from '@/onenetwork/constants/onenetwork.regions.const'
import { isObject } from 'lodash'
import moment from 'moment'

export const FO_STATUS_OPTIONS = [
  { label: 'Sắp diễn ra', code: 'coming_soon' },
  { label: 'Đang diễn ra', code: 'ongoing' },
]

export const FO_STATUS_OPTIONS_DETAIL = [
  { label: 'Sắp diễn ra', code: 'coming_soon' },
  { label: 'Đang diễn ra', code: 'ongoing' },
  { label: 'Đã kết thúc', code: 'ended' },
]

export const initialValuesCreateFO = {
  name: '',
  started_at: moment().toDate(),
  ended_at: moment().add(30, 'minutes').toDate(),
  status: 'coming_soon',
  province_id: null,
  ward_id: null,
  deposit: null,
  items: [
    {
      province_id: null,
      district_id: null,
      ward_id: null,
      price_from: null,
      price_to: null,
      name: '',
      real_estate_ids: [],
      deposit: null,
    },
  ],
}

export const parseFormDataFO = (
  data: any,
) => {
console.log(data)
  const items = [
    {
      province_id: data.province_id,
      district_id: data.district_id || null,
      ward_id: data.ward_id || null,
      real_estate_ids: data?.real_estate_ids || [],
      price_from: data?.price_from || null,
      price_to: data?.price_to || null,
      deposit: data?.deposit || null,
      keyword: data?.keyword || [],
    },
  ]
  return {
    name: data.name,
    started_at: moment(data.started_at).format('YYYY-MM-DD HH:mm:00'),
    ended_at: moment(data.ended_at).format('YYYY-MM-DD HH:mm:00'),
    status: data.status,
    items: items,
  }
}

export const initialValuesDetailFO = (data: any) => {
  return {
    ...data,
    name: data.name,
    started_at: moment(data.started_at).format('YYYY-MM-DD HH:mm'),
    ended_at: moment(data.ended_at).format('YYYY-MM-DD HH:mm'),
    status: data.status,
    items: data.items,
  }
}

export const getRegionFitter = (regionId: string, districtId: string) => {

  //return array of region and district
  const region = regions.find((item: any) => +item.id === +regionId);

  const district = region?.districts.find((item: any) => +item.id === +districtId)
  return [region, district]
}
